import type { SquareWithNumbers } from '../../types';

export const initialState = {
  squares: [] as SquareWithNumbers[],
  grid: [] as SquareWithNumbers[][],
  isLoading: false,
  error: null as string | null,
  boardId: null as string | null,
};
